var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{staticClass:"PageFooter"},[_c('p',{staticClass:"mb-0 copyright"},[_c('span',[_vm._v(" ©"+_vm._s(_setup.copyrightYear)+" "+_vm._s(_setup.copyrightName)),(_setup.trademarked)?_c('span',[_vm._v("™")]):_vm._e(),(_setup.registered)?_c('span',[_vm._v("®")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }